import { AuthEngineState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

const authenticationEngineConfigs: AuthEngineState = {
	isAuthenticated: false,
	isLoading: false,
	authenticationError: false,
	authorizationRoles: [],
	userInfo: {
		localAccountId: '',
		homeAccountId: '',
		displayName: '',
		email: '',
	},
};

export default authenticationEngineConfigs;
